/* __next_internal_client_entry_do_not_use__ PortalTooltip auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getDocumentOrThrow } from "@faire/web--source/common/globals/getDocument";
import { Column } from "@faire/web--source/slate/Layout";
import { offset } from "@floating-ui/dom";
import { useFloating } from "@floating-ui/react";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
/**
 * This is a wrapper wraps web-ui's tooltip in the so it can be positioned
 * with floating-ui, and react portal to overcome some limitation with
 * position: absolute
 */ export var PortalTooltip = function(props) {
    var bodyRef = React.useRef(null);
    useEffect(function() {
        bodyRef.current = getDocumentOrThrow().body;
    }, []);
    var _React_useState = _sliced_to_array(React.useState(false), 2), isOpen = _React_useState[0], setIsOpen = _React_useState[1];
    var _props_tooltipMainAxisOffset, _props_tooltipCrossAxisOffset;
    var _useFloating = useFloating({
        placement: props.placement,
        middleware: [
            offset({
                mainAxis: (_props_tooltipMainAxisOffset = props.tooltipMainAxisOffset) !== null && _props_tooltipMainAxisOffset !== void 0 ? _props_tooltipMainAxisOffset : 0,
                crossAxis: (_props_tooltipCrossAxisOffset = props.tooltipCrossAxisOffset) !== null && _props_tooltipCrossAxisOffset !== void 0 ? _props_tooltipCrossAxisOffset : 0
            })
        ]
    }), floatingStyles = _useFloating.floatingStyles, refs = _useFloating.refs;
    var handleMouseOver = function() {
        var _props_onMouseOver;
        setIsOpen(true);
        (_props_onMouseOver = props.onMouseOver) === null || _props_onMouseOver === void 0 ? void 0 : _props_onMouseOver.call(props);
    };
    var handleMouseOut = function() {
        setIsOpen(false);
    };
    var _props_align, _props_tooltipZIndex;
    return /*#__PURE__*/ _jsxs(Column, {
        className: props.className,
        "data-test-id": props["data-test-id"],
        ref: refs.setReference,
        onMouseEnter: handleMouseOver,
        onMouseLeave: handleMouseOut,
        justify: "center",
        align: (_props_align = props.align) !== null && _props_align !== void 0 ? _props_align : "center",
        children: [
            props.children,
            isOpen && bodyRef.current ? /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ _jsx("div", {
                ref: refs.setFloating,
                style: _object_spread_props(_object_spread({}, floatingStyles), {
                    zIndex: (_props_tooltipZIndex = props.tooltipZIndex) !== null && _props_tooltipZIndex !== void 0 ? _props_tooltipZIndex : 5
                }),
                children: props.tooltip
            }), bodyRef.current) : null
        ]
    });
};
